<template>
  <div class="custom-modal" id="subevent-modal">
    <div class="modal-body">
      <div class="actions-list">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button icon="fas fa-plus" type="primary" size="small" :loading="loading == 'createSub'" round @click="createSubEvent">{{ $t("registrationManagement.subeventRegistrations.createSubevent") }}</el-button>
          </li>
        </ul>
      </div>
      <transition name="slide-fade">
        <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("registrationManagement.subeventRegistrations.filter") }}</h5>
              <span>{{ $t("registrationManagement.subeventRegistrations.filterMsg") }}</span>
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-button @click="$store.state.subevents.filter.searchTerm = ''" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round></el-button>
              </el-button-group>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-12">
                <el-input clearable v-model="$store.state.subevents.filter.searchTerm" :placeholder="$t('registrationManagement.subeventRegistrations.searchPlaceholder')"></el-input>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div v-if="false">
        <upgrade-overlay height="300px"></upgrade-overlay>
      </div>
      <template v-else-if="$store.state.subevents.items.length > 0">
        <div class="custom-grid-table-header subevents-grid-template">
          <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
          <div>{{ $t("registrationManagement.subeventRegistrations.title") }}</div>

          <el-tooltip effect="dark" placement="top-start">
            <div class="tooltip-wrapper" slot="content">{{ $t("registrationManagement.subeventRegistrations.mobileRegisterMsg") }}</div>
            <span>
              {{ $t("registrationManagement.subeventRegistrations.mobileRegister") }}
              <i class="el-icon-info"></i>
            </span>
          </el-tooltip>
          <div>{{ $t("registrationManagement.subeventRegistrations.view") }}</div>
          <div></div>
        </div>
        <draggable :list="$store.state.subevents.items" tag="div" handle=".el-icon-s-grid" class="list-group-o sub-events-container" v-bind="dragOptions" @start="dragList = true" @end="changeSubEventSort">
          <div class="item" v-for="item in $store.state.subevents.items" :key="item.id" :class="{ passive: !item.isActive }">
            <div class="table-icon">
              <i class="burger" :class="loading == item.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
            </div>
            <div class="img-title">
              {{ item.title }}
            </div>

            <div class="limit">
              <span class="isMobileActive" v-if="item.enableMobileRegistrations">{{ $t("registrationManagement.subeventRegistrations.active") }}</span>
              <span class="isMobilePassive" v-else>{{ $t("registrationManagement.subeventRegistrations.passive") }}</span>
            </div>
            <div><el-switch v-model="item.isActive" :disabled="loading == item.id" @change="toggleItem(item.id)"></el-switch></div>
            <div class="action-btns">
              <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                <el-button
                  type="primary"
                  icon="fas fa-pen"
                  circle
                  size="mini"
                  @click="
                    subEventId = item.id;
                    addNewSubEvent = true;
                  "
                ></el-button>
              </el-tooltip>
              <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                  <el-button slot="reference" type="danger" :loading="loading == 'deleteSubItem' + item.id" icon="fas fa-trash" circle size="mini"></el-button>
                </el-popconfirm>
              </el-tooltip>
            </div>
          </div>
        </draggable>
      </template>

      <el-row v-else>
        <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-events-v2-lottie'" :title="$t('registrationManagement.subeventRegistrations.subevents')" @btnAdd="createSubEvent" @btnRefresh="false" :buttonAdd="true" :buttonRefresh="false" :loading="loading" />
      </el-row>
      <el-dialog :close-on-click-modal="false" :visible.sync="addNewSubEvent" :title="$t('event.tags.addSubEvent')" class="large" center append-to-body destroy-on-close>
        <SubEventAddUpdate @closeDialog="addNewSubEvent = false" :id="subEventId" v-if="addNewSubEvent" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import SubEventAddUpdate from "../SubEventAddUpdate.vue";
import SubEventRegistrationAdd from "../SubEventRegistrationAdd";
import SubEventRecords from "../SubEventRecords.vue";

import PaymentDetail from "../PaymentDetail";
import axios from "axios";
import PageCountInfo from "../PageCountInfo";
import ParticipantMini from "../ParticipantMini";
import $ from "jquery";
export default {
  components: {
    SubEventRegistrationAdd,
    PaymentDetail,
    PageCountInfo,
    ParticipantMini,
    SubEventAddUpdate,
    SubEventRecords,
    draggable
  },
  data() {
    return {
      recordsDialog: false,
      subEventId: null,
      addNewSubEvent: false,
      subUpdateForm: null,
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "speaker",
      detailData: null,
      detailDialog: false,
      participantData: null,
      loading: false,
      dragList: false,
      subEventSort: null
    };
  },

  methods: {
    async downloadTemplate(id) {
      this.$message.info(this.$t("generic.generatingPleaseWait"));
      var res = await this.$store.dispatch("exportXlscx", { type: 17, itemId: id, queryJson: null });
      if (!res.data.alert.hasError) {
        window.open(res.data.data.url, "_blank");
      }
    },
    async createSubEvent() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "createSub";
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateSubEvent", {
          id: null,
          title: "New Sub-event Title " + (this.$store.state.subevents.items.length + 1),
          details: "New Sub-event Details",
          isActive: true,
          stock: 0,
          stockControl: 0,
          enableStockControl: false,
          enableMobileRegistrations: false,
          enableAutomaticApproval: false,
          enableRegistrationAutomation: false,
          controlType: 0,
          registrationType: 0,
          tagId: this.tagList[0].id,
          tagIds: [],
          registrationControlItems: []
        });
        this.loading = false;
        if (!res.data.alert.hasError) {
          this.$store.dispatch("getEventProgram");

          this.subEventId = res.data.data.item.id;
          this.addNewSubEvent = true;
        }
      }, 500);
    },
    async changeSubEventSort() {
      if (this.subEventSort != null) clearTimeout(this.subEventSort);
      this.loading = "loadingList";
      this.subEventSort = setTimeout(async () => {
        var payload = [];
        this.$store.state.subevents.items.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveSubEventOrder", payload);
        await this.$store.dispatch("getSubEvents");
        this.loading = false;
      }, 500);
      this.dragList = false;
    },
    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getSubEvents");
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },

    itemAddedSubEvent() {
      this.$store.dispatch("getSubEvents");
    },
    itemUpdatedSubEvent(item) {
      var subIndex = this.$store.state.subevents.items.findIndex(x => x.id == item.id);
      this.$store.state.subevents.items.splice(subIndex, 1, item);
    },
    confirmSubEventRegistration(payload) {
      this.$store.dispatch("confirmSubEventRegistration", {
        ...payload,
        context: this
      });
    },
    cancelSubEventRegistration(payload) {
      this.$store.dispatch("cancelSubEventRegistration", {
        ...payload,
        context: this
      });
    },
    prepareParticipantMini(row) {
      return {
        firstName: row.firstName,
        lastName: row.lastName,
        tagID: row.tagID,
        id: row.id
      };
    },
    itemUpdated(item) {
      var index = this.$store.state.subeventregistrations.items.findIndex(k => k.id == item.id);
      if (index != -1) {
        this.$store.state.subeventregistrations.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getSubEventRegistrations");
    },
    handleSizeChange(take) {
      this.$store.commit("setSubEventRegistrationTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setSubEventRegistrationPage", page);
    },
    async deleteItem(id) {
      this.loading = "deleteSubItem" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("deleteSubEvent", id);
        this.loading = false;
      }, 500);
    },
    async toggleItem(id) {
      this.loading = id;
      await this.$store.dispatch("togglerSubEvent", id);
      setTimeout(() => {
        this.loading = false;
      }, "500");
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleSubEventRegistration", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedSubEventRegistrations", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  async beforeMount() {
    await Promise.all([this.$store.dispatch("getSubEvents"), this.$store.dispatch("getTags"), this.$store.dispatch("getRegisterForm")]);
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    tagList() {
      return this.$store.getters.getTagsList;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    skip() {
      return (this.$store.state.subevents.filter.page - 1) * this.$store.state.subevents.filter.take;
    },
    take() {
      return this.skip + this.$store.state.subevents.items.length;
    }
  },
  watch: {
    "$store.state.subevents.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getSubEvents");
      }, 500);
    },
    "$store.state.subevents.filter.subEventIDs": function(val) {
      this.$store.dispatch("getSubEvents");
    }
  }
};
</script>

<style lang="less">
#subevent-modal {
  .actions-list {
    width: 100%;
    .navbar-nav {
      display: flex;
      flex-direction: row;
      gap: 10px;
      justify-content: flex-end;
    }
    padding-bottom: 1rem;
  }
}
.subevents-grid-template {
  grid-template-columns: 36px 1fr 150px 100px 60px;
}

.sub-events-container {
  display: flex;
  flex-direction: column;
  .item {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: unset;
    }

    .img-title {
      font-size: 14px;
      color: #292f3b;
      font-weight: 600;
      line-height: normal;

      & > img {
        border-radius: 50%;
        width: 45px;
        height: 45px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        overflow: hidden;
        border: 3px solid white;
      }
    }
    .limit {
      font-weight: 500;
      color: #292f3b;

      .isLimited {
        color: #505763;
        &.isOver {
          color: #ff6565;

          b {
            color: #ff6565 !important;
          }
        }

        b {
          color: #292f3b;
          font-weight: 600;
        }
      }

      .isCool {
        color: #03658c;

        i {
          font-size: 14px;
        }
      }

      .isMobileActive {
        color: #03658c;
        b {
          font-weight: 600;

          &.autoDisabled {
            color: #292f3b;
          }
        }
      }

      .isMobilePassive {
        color: #ff6565;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;

    &.passive {
      background-color: #fff2f2 !important;
    }

    display: grid;
    grid-template-columns: 36px 1fr 150px 100px 60px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 0.5rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/eventprogram/EventProgramSubEventList.vue